import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominaTimbresTimbre', NominaTimbresTimbre)

function NominaTimbresTimbre($http) {
  this.get = _get

  function _get(id_nomina, id_proyecto, id_colaborador, indice) {
    return $http.get('api/nominas/nomina/timbres/timbre', {
      params: {
        id_nomina: id_nomina,
        id_proyecto: id_proyecto,
        id_colaborador: id_colaborador,
        indice: indice,
      },
      schema: NominaTimbresTimbreSchema,
    })
  }

  let NominaTimbresTimbreSchema = {
    descuentos: 'number',
    fecha_pago: 'date',
    id_regimen_fiscal: 'number',
    impuestos: 'number',
    salario_diario_integrado: 'number',
    pendiente: 'boolean',
    status_pagado: 'boolean',
    status_timbrado: 'boolean',
    status_cancelacion: 'boolean',
    subtotal: 'number',
    timbrado_fecha: 'timestamp',
    timbrado_fecha_recibido: 'timestamp',
    total: 'number',
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Timbres/Timbre.js